var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionQuickSell } from "./actionQuickSell";
var initial = {
    productInfo: undefined,
};
export var reducerQuickSell = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionQuickSell.Info:
            return __assign({}, state, { productInfo: action.productInfo });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-sell-dialog/reducerQuickSell.ts
// module id = 2973
// module chunks = 3